// Local translations
export const T = {
  en_GB: {
    goalPages: "goal pages",
    globalPages: "global pages",
    message: (name: string, pageLabel: string) =>
      `The "${name}" component cannot be shown on ${pageLabel} (misplaced component).`,
  },
  nb_NO: {
    goalPages: "målsider",
    globalPages: "globale sider",
    message: (name: string, pageLabel: string) =>
      `Komponenten «${name}» kan ikke vises på ${pageLabel} (feilplassert komponent).`,
  },
} as const;
